/**
 * @fileoverview GitHub User Metrics API Service
 * @description API calls for the GitHub User Metrics feature
 */

import { apiClient } from './client';

const BASE = '/v1/github-user-metrics';

export const githubUserMetricsApi = {
  getHealth: () => apiClient.get(`${BASE}/health`),
  getTrackedUsers: () => apiClient.get(`${BASE}/users`),
  addTrackedUsers: (usernames) => apiClient.post(`${BASE}/users`, { usernames }),
  removeTrackedUser: (username) => apiClient.delete(`${BASE}/users/${username}`),
  getAllMetrics: (force = false, month = null, scope = null) => {
    const params = new URLSearchParams();
    if (force) params.set('force', 'true');
    if (month) params.set('month', month);
    if (scope) params.set('scope', scope);
    const qs = params.toString();
    return apiClient.get(`${BASE}/metrics${qs ? `?${qs}` : ''}`);
  },
  getAvailableMonths: () => apiClient.get(`${BASE}/months`),
  getMonthlyCostSummary: () => apiClient.get(`${BASE}/metrics/monthly-cost`),
  getUserMetrics: (username, force = false) => apiClient.get(`${BASE}/metrics/${username}${force ? '?force=true' : ''}`),
  refreshAllMetrics: () => apiClient.post(`${BASE}/metrics/refresh`),
};
